/**
 * Current version of the SUF quiz data structure.
 * This version number is used to ensure compatibility when restoring abandoned cart data.
 * When the quiz structure changes, increment this version to prevent restoring incompatible data.
 */
export const DEFAULT_SUF_QUIZ_VERSION = 1;

export const DEFAULT_DIRECT_SALES_QUIZ_VERSION = 1;
